import { Task } from '@/types/Task';
import { OpportunitiesByTask, OpportunityResponse } from './types';

export type State = {
  tasks: Array<Task>;
  tasksLoading: boolean;
  opportunities: OpportunitiesByTask;
  potentialOps: Array<OpportunityResponse>;
  isLoading: boolean;
  isModalLoading: boolean;
  isModalSubmitting: boolean;
  lastMadeTaskId: string | number | null;
};

export const state: State = {
  tasks: [],
  tasksLoading: false,
  opportunities: {},
  potentialOps: [],
  isLoading: false,
  isModalLoading: false,
  isModalSubmitting: false,
  lastMadeTaskId: null,
};
